import { render, staticRenderFns } from "./StoreDetail2.vue?vue&type=template&id=4bacb5ef&"
import script from "./StoreDetail2.vue?vue&type=script&lang=js&"
export * from "./StoreDetail2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports